import { UM_SERVICE } from '../api';
/**
 * Sets a cookie with the specified name and value, and optional expiration in days.
 *
 * @param name - The name of the cookie.
 * @param value - The value to store in the cookie.
 * @param days - Optional. The number of days until the cookie expires. Defaults to 0.5.
 */
export const setCookie = (name: string, value: string, days = 0.5) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

// fetch frontend env,get uimanager service url;
export const initEnv = async () => {
  try {
    const frontendEnv = await fetch('/env.json').then(res => res.json());
    let serviceUrl = frontendEnv.serviceUrl;
    if (serviceUrl) {
      let backendEnv = await UM_SERVICE?.envJson.getEnvJson({ baseURL: serviceUrl });
      if (backendEnv?.environment?.moduleUrls && !backendEnv?.environment?.moduleUrls?.uimanager) {
        backendEnv.environment.moduleUrls.uimanager = serviceUrl;
      }
      (globalThis as any).UIMANAGER_ENV = backendEnv;
    } else {
      console.warn('Service URL not found in frontend env');
    }
  } catch (error) {
    console.error('Failed to load environment configuration:', error);
  }

  if (!globalThis.UIMANAGER_ENV) {
    throw new Error('UI Manager environment configuration not found');
  }
}


